const {handleCountrySelect} = require('./components/helpers').methods;

function init () {
    // grab all the selects that have the data attribute data-state-selects
    const countrySelects = $('select[data-state-selects]');

    countrySelects.each(function () {
        handleCountrySelect($(this), 'contact');
    });

    //add 'question about' handler
    $('#contact-topic').change(function () {
        const select = $('#contact-topic option:selected').val();

        switch (select) {
            case 'Repair or Service':
            case 'Strings':
            case 'Electronics':
            case 'Registration':
            case 'Specifications':
                showHiddenFields();
                break;
            default:
                hideHiddenFields();
                break;
        }
    });
}

function showHiddenFields () {
    $('.contact-us-model').show();
    $('.contact-us-sn').show();
}

function hideHiddenFields () {
    $('.contact-us-model').hide();
    $('.contact-us-sn').hide();
}

module.exports = {
    init
};
